namespace GeniuzPOS.InitialData {
    export namespace PsPanelItemButtonService {
        export const baseUrl = 'InitialData/PsPanelItemButton';

        export declare function Create(request: Serenity.SaveRequest<PsPanelItemButtonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPanelItemButtonRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPanelItemButtonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPanelItemButtonRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsPanelItemButton/Create",
            Update = "InitialData/PsPanelItemButton/Update",
            Delete = "InitialData/PsPanelItemButton/Delete",
            Retrieve = "InitialData/PsPanelItemButton/Retrieve",
            GetNextNumber = "InitialData/PsPanelItemButton/GetNextNumber",
            List = "InitialData/PsPanelItemButton/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetNextNumber', 
            'List'
        ].forEach(x => {
            (<any>PsPanelItemButtonService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
